<template>
  <div>
    <h1>{{ $t("investor.title") }}</h1>
    <b-form @submit="onSubmit">
      <b-form-group id="input-group-name" label-for="name">
        <b-form-input
          id="name"
          v-model="form.name"
          :placeholder="$t('investor.name')"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-phone" label-for="phone">
        <b-form-input
          id="phone"
          v-model="form.phone"
          type="tel"
          :placeholder="$t('investor.phone')"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-nickname" label-for="nickname">
        <b-form-input
          id="nickname"
          v-model="form.nickname"
          :placeholder="$t('investor.nickname')"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-email" label-for="email">
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          :placeholder="$t('investor.email')"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-address" label-for="address">
        <b-form-input
          id="address"
          v-model="form.address"
          :placeholder="$t('investor.address')"
          required
        ></b-form-input>
      </b-form-group>

      <div class="d-flex flex-column flex-md-row gap-md-3">
        <b-form-group
          id="input-group-city"
          label-for="city"
          class="w-100 w-md-50"
        >
          <b-form-input
            id="city"
            v-model="form.city"
            :placeholder="$t('investor.city')"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-state"
          label-for="state"
          class="w-100 w-md-50"
        >
          <b-form-input
            id="state"
            v-model="form.state"
            :placeholder="$t('investor.state')"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group id="input-group-country" label-for="country">
        <b-form-input
          id="country"
          v-model="form.country"
          :placeholder="$t('investor.country')"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group :label="$t('investor.investment')">
        <b-form-checkbox-group
          id="investment"
          v-model="form.investment"
          :options="investmentOptions"
          class="investment-options"
        ></b-form-checkbox-group>
      </b-form-group>

      <div class="w-100 text-md-end">
        <p class="my-2">{{ $t("investor.howMany") }}</p>
        <div class="w-100 d-flex justify-content-md-end">
          <b-form-spinbutton
            id="times"
            v-model="form.times"
            class="w-50 w-md-25 me-2"
          ></b-form-spinbutton>
          <label for="times">{{ $t("investor.times") }}</label>
        </div>
      </div>

      <b-button type="submit" class="btn-gold">{{
        $t("investor.submit")
      }}</b-button>
    </b-form>
  </div>
</template>

<script>
import {
  BButton,
  BForm,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormSpinbutton,
} from "bootstrap-vue";
export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckboxGroup,
    BFormSpinbutton,
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        nickname: "",
        email: "",
        address: "",
        city: "",
        state: "",
        country: "",
        investment: [],
        times: 1,
      },
      investmentOptions: [
        {
          text: this.$t("investor.50"),
          value: "50",
        },
        {
          text: this.$t("investor.100"),
          value: "100",
        },
        {
          text: this.$t("investor.200"),
          value: "200",
        },
        {
          text: this.$t("investor.500"),
          value: "500",
        },
        {
          text: this.$t("investor.1000"),
          value: "1000",
        },
        {
          text: this.$t("investor.5000"),
          value: "5000",
        },
        {
          text: this.$t("investor.10000"),
          value: "10000",
        },
        {
          text: this.$t("investor.20000"),
          value: "20000",
        },
      ],
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.$emit("submitted", JSON.stringify(this.form));
      //   调用API提交表单数据
      alert(JSON.stringify(this.form));
    },
  },
};
</script>

<style>
.application-form {
  h5 {
    color: #3b3e51;
    font-size: 1.3rem;
    margin: 1rem 0 2rem;
  }
  input,
  textarea {
    background-color: #f4f9fe;
    border: none;
    margin-bottom: 1rem;
  }
  button.btn-gold {
    padding: 0.5rem 2rem;
    border-radius: 1.5rem;
    margin: 1rem 0;
  }
  .investment-options {
    margin-top: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .custom-control {
      width: 100%;
      font-size: 1rem;
      line-height: 2rem;
      input[type="checkbox"] {
        display: none;
      }
      label {
        position: relative;
        cursor: pointer;
        padding-left: 1.6rem;
      }
      label::before {
        content: "";
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 1.3rem;
        margin-right: 0.5rem;
        background-color: transparent;
        border: 3px solid #ff00004d;
      }
      input[type="checkbox"]:checked + label:before {
        content: "\2713";
        color: white;
        font-size: 0.8rem;
        line-height: 1.3rem;
        background-color: rgb(19, 200, 255);
        border: 3px solid rgb(19, 200, 255);
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .application-form {
    .investment-options {
      .custom-control {
        width: 45%;
      }
    }
  }
}
</style>
